import { render, staticRenderFns } from "./Moderations.vue?vue&type=template&id=590b8e98"
import script from "./Moderations.vue?vue&type=script&lang=js"
export * from "./Moderations.vue?vue&type=script&lang=js"
import style0 from "./Moderations.vue?vue&type=style&index=0&id=590b8e98&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports